export default "__VITE_ASSET__FIK5uRPE__"